import InfiniteScrollArticleCards from "./InfiniteScrollArticleCards";

export default InfiniteScrollArticleCards;
